






































































































































































































































































































































































































































































import * as Enums from '@/enums.ts';
import * as Util from '@/util.ts';
import * as Constants from '@/constants.ts';
import * as firebase from 'firebase/app';
import * as firebaseui from 'firebaseui';
import * as ExchangeFuncs from '@/util-funcs/exchange-object-funcs';
import { presetThemes } from '@/preset-themes.ts';
import storage from 'local-storage-fallback';
import Vue from 'vue';

export default Vue.extend({
  name: 'app',
  data() {
    const recentlyUsedStationCode = Util.localStoreGet('stationCode', true);
    let subdomainPermalinkId = '';

    // Check for subdomain permalinkId.
    if (!['tm-menu-test.web.app', 'tm-menu-test.firebaseapp.com', 'localhost'].includes(window.location.hostname)) {
      const hostNameParts = window.location.hostname.split('.');
      subdomainPermalinkId = hostNameParts.length === 3 ? hostNameParts[0] : '';
    }

    // Check for slug permalinkId.
    const firstSlugPart = window.location.pathname.substr(1).split('/')?.[0];
    // This can only be a valid permalinkId of it is not already one of the routes we use for navigation.
    const slugPermalinkId = Object.values(Constants.allRoutes).includes(`/${firstSlugPart}`) ? '' : firstSlugPart;
    const permalinkId = subdomainPermalinkId || slugPermalinkId;
    const isEmbedded = Util.getParameterByName('e') === 'true';

    return {
      carouselKey: 0,
      APP_VERSION: process.env.APP_VERSION,
      permalinkWasInUrl: Boolean(permalinkId),
      codeWasInUrl: Boolean(Util.getParameterByName('c')),
      stationCodeIsOld: Boolean(recentlyUsedStationCode),
      isMounted: false,
      isLoading: false,
      isFullNav: false,
      isInitialLoad: false,
      showSameStationCodePrompt: false,
      showSnackbar: false,
      showCodeEntryPage: false,
      snackBarMessage: '',
      showSignIn: false,
      signInMessage: '',
      snackBarType: Enums.eSnackBarTypes.notice,
      eSnackBarTypes: Enums.eSnackBarTypes,
      isTestMode: Boolean(Util.getParameterByName('test')),
      stationCode: (Util.getParameterByName('c') || recentlyUsedStationCode || '').toUpperCase(),
      providedSubscriptionId: Util.getParameterByName('sub'),
      providedEstablishmentId: Util.getParameterByName('est'),
      isTestingMode: Util.getParameterByName('test') === 'true',
      establishmentName: Util.localStoreGet('establishmentName', true) || '',
      permalinkId,
      showGlobalModal: false,
      showGlobalModalTitle: '',
      showGlobalModalModalMsg: '',
      showConfirmationModal: false,
      confirmationModalTitle: '',
      confirmationModalMsg: '',
      confirmationModalQueue: [],
      showPromotionModal: false,
      signInFormInitialized: false,
      showOrderAheadTimePicker: false,
      signInAllowClose: true,
      uiConfig: null,
      authUi: null,
      eAppModes: Enums.eAppModes,
      allRoutes: Constants.allRoutes,
      presetThemes,
      currTheme: 'Fresh',
      currentConfirmationModalAffirmativeFunc: (): void => undefined,
      currentConfirmationModalNegativeFunc: (): void => undefined,
      isMobile: Util.mobileCheck(),
      isEmbedded,
      allRountes: Constants.allRoutes,
      isProductionEnv: Util.isProductionEnv(),
    };
  },
  computed: {
    cannotOrder(): boolean {
      return this.$store.getters.cannotOrder;
    },
    modalVisible(): boolean {
      return this.$store.state.modalVisible;
    },
    readyToShowContent(): boolean {
      return this.$store.state.gotAllResources;
    },
    isDemoLocation(): boolean {
      return this.$store.state.isDemoLocation;
    },
    showNavBar(): boolean {
      return this.$store.state.showNavBar;
    },
    appMode(): Enums.eAppModes {
      return this.$store.state.appMode;
    },
    isKioskMode(): boolean {
      return this.$store.state.isKioskMode;
    },
    isViewOnlyMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.viewOnly;
    },
    isTablesideMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.tableside;
    },
    isTakeoutMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.takeout;
    },
    promotion(): Promotion {
      return this.$store.state.currentLocation.promotion;
    },
    deleteDisabled(): boolean {
      return this.$data.stationCode.length < 1;
    },
    enterCodeDisabled(): boolean {
      return this.$data.stationCode.length < 3;
    },
    isLoggedIn(): boolean {
      return this.$store.state.isLoggedIn;
    },
    numberOfOrders(): string {
      return this.$store.state.toBeSentOrders.length ? this.$store.state.toBeSentOrders.length.toString() : '';
    },
    currentLocation(): EstablishmentLocation {
      return this.$store.state.currentLocation;
    },
  },
  mounted() {
    this.$data.isMounted = true;
    if (!this.$store.state.locale) {
      this.setDefaultLanguage();
    }
    this.checkCode();
  },
  methods: {
    anonymousSignIn() {
      Util.anonymousSignIn();
    },
    getOrderingFromString(): string {
      return Util.getOrderingFromString();
    },
    routerPush(args: any) {
      Util.routerPush(args);
    },
    isOnPage(path: string) {
      const currPath = this.$router.mode === 'hash' ? window.location.hash : window.location.pathname;
      return currPath.includes(path);
    },
    initializeEstablishmentData(givenStationCode: string | null = null, reset: boolean = true) {
      const self: any = this;

      Util.routerPush({ path: Constants.allRoutes.menu });

      if (givenStationCode) {
        this.$data.stationCode = givenStationCode;
      }

      if (!this.$data.stationCode) {
        Util.showError('Cannot initialize without a station code');
      }

      // Reset the store to the initial state for a new session.
      if (reset) {
        this.$store.commit('reset');
      }

      this.$store.commit('setPermalinkId', this.$data.permalinkId);
      this.$store.commit('setIsEmbedded', this.$data.isEmbedded);

      // Parse the station code and extract the location id
      const stationCodeLastTwoCharacters = this.$data.stationCode.substr(-2);
      const locationIdString = this.$data.stationCode.substr(0, this.$data.stationCode.length - 2);
      const locationId = parseInt(locationIdString, 36);
      this.$store.commit('setLocationId', locationId);

      // Hide the code entry page if it's not already hidden.
      this.$data.showCodeEntryPage = false;

      // If we are loading the first location for this session we have to enable this to hide FOUC.
      this.$data.isInitialLoad = true;

      // Enable kiosk mode if needed.
      const isKioskMode = Util.getParameterByName('isKioskMode') ? Util.getParameterByName('isKioskMode') === 'true' : Util.localStoreGetSimple('isKioskMode') === 'true';
      this.$store.commit('setIsKioskMode', isKioskMode);
      if (isKioskMode) {
        Util.showGlobalModal(Util.t?.orderSubmitted, Util.t?.kioskOrderCompleteMessage);
      }

      // Handle special locations
      this.$store.commit('setIsDemoLocation', Constants.DEMO_LOCATION_CODES.includes(locationIdString));

      // If not view only mode then we want to initialize with a station code.
      if (!this.isViewOnlyMode) {
        Util.localStoreSet('stationCode', this.stationCode);
      }

      Util.showLoading();

      if (this.$data.providedSubscriptionId && this.$data.providedEstablishmentId) {
        // This is just for iframe menu previews in the manager.
        const subDoc: firebase.firestore.DocumentReference = Util.currFirestore.collection('subscriptions').doc(this.$data.providedSubscriptionId);

        this.$store.commit('setCurrentSubscriptionDoc', subDoc);
        initWithSubDoc(this.$data.providedEstablishmentId);
      } else {
        // Use the location ID from the station code to find the approriate subscription
        Util.currFirestore
          .collection('systemManagementDocs')
          .doc('locationMetadata')
          .collection('locationLedger')
          .where('locationId', '==', locationId)
          .limit(1)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.empty) {
              onInitError(Util.t?.codeIsInvalid);
            } else {
              let locationLedgerDocData: any;
              querySnapshot.forEach((q) => (locationLedgerDocData = q.data()));
              // Retrieve the sub doc from the ledger data.
              const subDoc: firebase.firestore.DocumentReference = locationLedgerDocData.subscriptionDoc;
              this.$store.commit('setCurrentSubscriptionDoc', subDoc);
              initWithSubDoc();
            }
          })
          .catch((error: any) => {
            onInitError(Util.t?.codeIsInvalid + ' ' + error?.message);
          })
          .finally(() => {
            Util.nonDebugLog('Location ledger promise resolved');
          });
      }

      function onInitError(str: string = '') {
        if (str) {
          self.showGlobalModalFunc(Util.t?.couldNotProceed, str);
        }
        self.stationCode = '';
        if (self.$store.state.locationsToPickFrom.length) {
          Util.routerPush({ path: Constants.allRoutes.locationSelection });
        } else {
          self.showCodeEntryPageFunc();
        }
        Util.hideLoading();
      }

      // TODO: consider storing this stuff in localstorage so that on refresh, if the locationId is the same and it's been less than 2 hours, we can just use the old stuff and save on firebase calls.
      // This might prove useful: https://firebase.google.com/docs/firestore/manage-data/enable-offline

      function initWithSubDoc(establishmentDocId: string = '') {
        const subDoc: firebase.firestore.DocumentReference = self.$store.state.currentSubscriptionDoc;

        subDoc
          .get()
          .then(async (docSnap) => {
            const subscriptionData = docSnap.data() as Subscription;

            if (!subscriptionData.isActive) {
              onInitError(Util.t?.inactiveSubscription);
              return;
            }

            self.$store.commit('setCurrentSubscriptionDoc', subDoc);
            self.$store.commit('setCurrentSubscriptionData', subscriptionData);
            self.$store.commit('setStationCode', self.$data.stationCode);

            Util.updateBannedUsers();

            await self.getAllResourcesForSubscription().catch(() => {
              onInitError();
              return;
            });

            // Get the appropriate establishment object.
            let currEstablishment: Establishment = Constants.EMPTY_ESTABLISHMENT;
            let currLocation: EstablishmentLocation | null = null;

            if (establishmentDocId) {
              const arrayWithSingleEstablishment: Establishment[] = self.$store.state.establishmentArray.filter((est: Establishment) => {
                return est.docId === establishmentDocId;
              });
              if (arrayWithSingleEstablishment.length) {
                currEstablishment = arrayWithSingleEstablishment[0];
              } else {
                onInitError('No establishment exists for given ID.');
                return;
              }
            } else {
              const arrayWithSingleLocation: EstablishmentLocation[] = self.$store.state.locationArray.filter((loc: EstablishmentLocation) => {
                return loc.locationId === locationId;
              });
              if (arrayWithSingleLocation.length) {
                currLocation = arrayWithSingleLocation[0];
                self.$store.commit('setCurrentLocation', currLocation);
                self.$store.commit('setCurrentLocationDoc', self.$store.state.currentSubscriptionDoc.collection('locationCollection').doc(currLocation.docId));
                currEstablishment = currLocation.establishment as Establishment;
                const stationIdRadix = currLocation.numberOfStations < 100 && !(stationCodeLastTwoCharacters === Constants.VIEW_ONLY_STATION_CODE || Constants.ALL_RESERVED_STATION_CODES.includes(stationCodeLastTwoCharacters)) ? 10 : 36;
                const stationId = self.$data.isTestingMode ? -1 : parseInt(stationCodeLastTwoCharacters, stationIdRadix);
                if (isNaN(stationId)) {
                  onInitError(Util.t?.codeIsInvalid);
                  return;
                }
                self.$store.commit('setStationId', stationId);
              } else {
                onInitError('No location exists for given ID.');
                return;
              }
            }

            self.$store.commit('setCurrentEstablishment', currEstablishment);
            Util.localStoreSet('establishmentName', currEstablishment.name);
            self.$data.establishmentName = currEstablishment.name;

            if (currLocation) {
              const orderAheadEnabled = currLocation.orderAheadEnabled;

              const todaysDateInISO89601 = new Date().toISOString().substr(0, 10);
              if (currLocation.closureDates?.includes(todaysDateInISO89601)) {
                onInitError(Util.t?.weAreClosedToday);
              }

              // Handle special stationIds and change to the appropriate mode
              if (stationCodeLastTwoCharacters === Constants.VIEW_ONLY_STATION_CODE) {
                self.setMode(Enums.eAppModes.viewOnly);
              } else if (Constants.TAKEOUT_STATION_CODES.includes(stationCodeLastTwoCharacters)) {
                if (currLocation.isTakeoutOn) {
                  if (self.$store.state.takeoutAvailable) {
                    self.setMode(Enums.eAppModes.takeout);
                  } else {
                    if (orderAheadEnabled && currLocation.takeoutTimeSlots) {
                      self.setMode(Enums.eAppModes.takeout);
                      Vue.nextTick(() => {
                        // Need a next tick to avoid having the modal closed due to a route change.
                        self.$data.showOrderAheadTimePicker = true;
                      });
                    } else {
                      onInitError(Util.t?.outsideTakeoutHours);
                      return;
                    }
                  }
                } else {
                  onInitError(Util.t?.takeoutIsNotAvailable);
                  return;
                }
              } else if (Constants.DELIVERY_STATION_CODES.includes(stationCodeLastTwoCharacters)) {
                if (currLocation.isDeliveryOn) {
                  if (self.$store.state.deliveryAvailable) {
                    self.setMode(Enums.eAppModes.delivery);
                  } else {
                    if (orderAheadEnabled) {
                      self.setMode(Enums.eAppModes.delivery);
                      Vue.nextTick(() => {
                        // Need a next tick to avoid having the modal closed due to a route change.
                        self.$data.showOrderAheadTimePicker = true;
                      });
                    } else {
                      onInitError(Util.t?.outsideDeliveryHours);
                      return;
                    }
                  }
                } else {
                  onInitError(Util.t?.deliveryIsNotAvailable);
                  return;
                }
              } else {
                if (currLocation.isTablesideOn) {
                  if (self.$store.state.tablesideAvailable) {
                    self.setMode(Enums.eAppModes.tableside);
                  } else {
                    onInitError(Util.t?.outsideTablesideHours);
                    return;
                  }
                } else {
                  onInitError(Util.t?.tablesideIsNotAvailable);
                  return;
                }
              }
            }

            if (!self.$store.state.themeWasInitialized) {
              Util.initTheme(currEstablishment);
            }

            const menuResourceArray: Menu[] = currEstablishment.menus;

            // Get the appropriate menu object.
            const arrayofMenusToShow = Util.getResourceArrayWithValidTimeslotsAndVisible(menuResourceArray);

            if (arrayofMenusToShow.length) {
              if (arrayofMenusToShow.length > 1) {
                self.$store.commit('setMenusToPickFrom', arrayofMenusToShow);
                Util.routerPush({ path: Constants.allRoutes.menuSelection });
              } else {
                self.$store.commit('setCurrentMenu', arrayofMenusToShow[0]);
              }
            } else {
              // If this is view only mode then probably better to show a menu than nothing at all.
              if (self.$store.state.appMode === Enums.eAppModes.viewOnly && menuResourceArray.length) {
                self.$store.commit('setCurrentMenu', menuResourceArray[0]);
              } else {
                onInitError('No applicable menus exist.');
              }
              return;
            }

            // Get pending order information if it exists.
            const toBeSentOrdersObjectString = Util.localStoreGet('toBeSentOrders');
            if (toBeSentOrdersObjectString) {
              const toBeSentOrders = JSON.parse(toBeSentOrdersObjectString);
              self.$store.commit('setToBeSentOrders', toBeSentOrders); // Need to set here since local storage will have more up to date information on a refresh.
            }

            // Get last pending order information if it exists.
            const lastSentOrdersObjectString = Util.localStoreGet('lastSentOrders');
            if (lastSentOrdersObjectString) {
              const lastSentOrders = JSON.parse(lastSentOrdersObjectString);
              self.$store.commit('setlastSentOrders', lastSentOrders); // Need to set here since local storage will have more up to date information on a refresh.
            }

            if (!self.isDemoLocation) {
              self.beginTutorial();
            }

            // Next tick to prevent the dialog closing due to a redirect.
            Vue.nextTick(() => {
              // Show the same station code prompt if there was a recently used station code, and there is no code param or permalink ID in the url and this is not a test session and not in dev mode, and not in kiosk mode.
              self.$data.showSameStationCodePrompt = self.stationCodeIsOld && !self.$data.isEmbedded && !self.$data.permalinkWasInUrl && !self.codeWasInUrl && !self.isTestMode && !self.isKioskMode;
            });

            if (!self.$data.showSameStationCodePrompt && !self.$data.isTestingMode && self.$store.state.appMode !== Enums.eAppModes.viewOnly) {
              if (currLocation) {
                Util.showNotice(Util.getOrderingFromString());
              } else {
                // This pathway is for testing purposes.
                Util.showNotice(Util.t?.youAreOrderingFromTesting.supplant([currEstablishment.name, self.$data.stationCode]));
                self.$store.commit('setStationId', 0);
              }
            }

            // Only do sign up stuff after we get all of the info for the current subscription.
            firebase.auth().onAuthStateChanged((user: firebase.User | null) => {
              if (user) {
                Util.setUpForSignedInAuthUser(user);
              } else {
                Util.logout();
                self.$store.commit('setInitializationComplete', true);
              }
            });

            if (self.$store.state.isInEurope && self.$store.state.appMode !== Enums.eAppModes.viewOnly) {
              Util.showGlobalModal(Util.t.gdprTitle, Util.t.gdprMessage);
            }

            self.isInitialLoad = false;
            self.showPromotionModalFunc(true);
            self.$forceUpdate();
          })
          .catch((error: any) => {
            onInitError('Could not get subscription data. ' + error?.message);
          })
          .finally(() => {
            Util.hideLoading();
          });
      }
    },
    // Resolves with true if the resources have been successfully fetched.
    getAllResourcesForSubscription(): Promise<boolean> {
      return new Promise((resolve: any, reject: any) => {
        if (this.$store.state.gotAllResources) {
          resolve(true);
          return;
        }

        // Fetch all the pertinent data for the subscription.
        Promise.all([Util.getResourceArrayFromDb('establishment'), Util.getResourceArrayFromDb('location'), Util.getResourceArrayFromDb('menu'), Util.getResourceArrayFromDb('menuCategory'), Util.getResourceArrayFromDb('menuItem'), Util.getResourceArrayFromDb('timeSlot'), Util.getResourceArrayFromDb('promotion'), Util.getResourceArrayFromDb('presetOptionGroup')])
          .then(() => {
            /*
            Since we aren't concered with updating any of the resources we can just convert all of the document references
            in state management to raw data. Can only do this after all of the resource arrays have been loaded since
            we subsitute the references with data objects using the masterResourceDictionary,  which is only built for
            a particular resource when masterResourceDictionary is called.
            */

            Util.recursivelyConvertAllDocRefsToDataInResourceArray('establishment');
            Util.recursivelyConvertAllDocRefsToDataInResourceArray('location');
            Util.recursivelyConvertAllDocRefsToDataInResourceArray('menu');
            Util.recursivelyConvertAllDocRefsToDataInResourceArray('menuCategory');
            Util.recursivelyConvertAllDocRefsToDataInResourceArray('menuItem');
            Util.recursivelyConvertAllDocRefsToDataInResourceArray('timeSlot');
            Util.recursivelyConvertAllDocRefsToDataInResourceArray('promotion');
            Util.recursivelyConvertAllDocRefsToDataInResourceArray('presetOptionGroup');

            this.$store.commit('setGotAllResources', true);
            resolve(true);
          })
          .catch((error) => {
            Util.showError(`Error getting resources for the subscription. ${error?.message}`);
            reject(false);
          });
      });
    },
    beginTutorial() {
      if (!this.isViewOnlyMode && Util.localStoreGetSimple('tutorialStep') === null) {
        Util.localStoreSetSimple('tutorialStep', '1');
        Util.doTutorialStep(1);
      }
    },
    showSnackBarFunc(str: string, snackBarType: string) {
      if (!str) {
        return;
      }
      this.$data.snackBarMessage = str;
      this.$data.snackBarType = snackBarType as Enums.eSnackBarTypes;
      this.$data.showSnackbar = true;
      Util.delay(() => {
        this.$data.showSnackbar = false;
      }, 4000);
    },
    backspace() {
      this.$data.stationCode = this.$data.stationCode.slice(0, this.$data.stationCode.length - 1);
    },
    virtualKeyboardPress(char: string) {
      if (this.$data.stationCode.length < 6) {
        this.$data.stationCode += char;
      }
    },
    onSubmitCode() {
      if (this.$data.stationCode) {
        this.$data.showSameStationCodePrompt = false;
        // Since the user is manually inputting a code, we no longer care about the permalinkId.
        this.checkCode();
        Util.routerPush({ path: Constants.allRoutes.menu });
      } else {
        Util.showError(Util.t?.enterACode);
      }
    },
    checkCode() {
      if (this.$data.isTestingMode) {
        this.initializeEstablishmentData();
      } else if (this.$data.permalinkId) {
        Util.currFirestore
          .collection('permalinks')
          .doc(this.$data.permalinkId)
          .get()
          .then((doc) => {
            if (doc.exists) {
              const permalinkData = doc.data() as EstablishmentPermalink;
              this.$store.commit('setPermalinkId', this.$data.permalinkId);
              this.$store.commit('setCurrentSubscriptionDoc', permalinkData.subscriptionDoc);
              this.getAllResourcesForSubscription().then(() => {
                const currEstablishment: Establishment = Util.masterResourceDictionary[permalinkData.establishmentDoc.id];
                this.$store.commit('setCurrentEstablishment', currEstablishment);
                Util.initTheme(currEstablishment);
                const locationsToPickFrom = this.$store.state.locationArray.filter((location: EstablishmentLocation) => {
                  if (!location.establishment) {
                    return false;
                  }
                  const isALocationWithTheGivenEstablishment = (location.establishment as Establishment).docId === currEstablishment.docId;
                  return isALocationWithTheGivenEstablishment;
                });
                if (locationsToPickFrom.length) {
                  this.$store.commit('setLocationsToPickFrom', locationsToPickFrom);
                  this.$data.showSameStationCodePrompt = false;
                  Util.routerPush({ path: Constants.allRoutes.locationSelection });
                } else {
                  Util.showError('There are no locations for this establishment');
                }
              });
            } else {
              this.showCodeEntryPageFunc();
              Util.showError(Util.t?.linkIsInvalid);
            }
          })
          .catch((error) => {
            this.showCodeEntryPageFunc();
            Util.showError(`Could not get permalink info. ${error?.message}`);
          });
      } else if (this.$data.stationCode) {
        // If it's a code erase it from the url to mitigate bookmarking.
        if (this.$router.currentRoute.path.includes('?c=') || this.$router.currentRoute.path.includes('&c=')) {
          Util.routerPush({ path: this.$route.path });
        }

        // Station codes can be either base 10 or base 36 but for the purposes of making sure that the code translate to a valid number >= 0 in either case we can just assume base 36.
        const stationCodeAsNumber = parseInt(this.$data.stationCode, 36);
        if (this.$data.stationCode.length >= 3 && !isNaN(stationCodeAsNumber) && stationCodeAsNumber >= 0) {
          this.initializeEstablishmentData();
        } else {
          this.showCodeEntryPageFunc();
          Util.showError(Util.t?.codeIsInvalid);
        }
      } else {
        this.showCodeEntryPageFunc();
      }
    },
    movedLocation() {
      this.$data.showSameStationCodePrompt = false;
      this.$data.stationCode = '';
      this.showCodeEntryPageFunc();
      Util.localStoreRemove('stationCode');
    },
    showConfirmationModalFunc(title: string, msg: string, onConfirmFunc = (): void => undefined, onCancelFunc = (): void => undefined) {
      if (this.$data.showConfirmationModal) {
        // If we're already showing the confirmation modal.
        this.$data.confirmationModalQueue.push({
          // Queue this confirmation modal to show up after the current one is closed.
          confirmationModalTitle: title,
          confirmationModalMsg: msg,
          currentConfirmationModalAffirmativeFunc: onConfirmFunc,
          currentConfirmationModalNegativeFunc: onCancelFunc,
        });
      } else {
        this.$data.showConfirmationModal = true;
        this.$data.confirmationModalTitle = title;
        this.$data.confirmationModalMsg = msg;
        this.$data.currentConfirmationModalAffirmativeFunc = onConfirmFunc;
        this.$data.currentConfirmationModalNegativeFunc = onCancelFunc;
      }
    },
    showCodeEntryPageFunc() {
      this.$data.showCodeEntryPage = true;
      this.$data.stationCode = '';
      this.$data.permalinkId = '';
    },
    showGlobalModalFunc(title: string, msg: string) {
      this.$data.showGlobalModal = true;
      this.$data.showGlobalModalTitle = title;
      this.$data.showGlobalModalModalMsg = msg;
    },
    onConfirmationYesClick() {
      this.currentConfirmationModalAffirmativeFunc();
      this.hideConfirmationDialog();
    },
    onConfirmationNoClick() {
      this.currentConfirmationModalNegativeFunc();
      this.hideConfirmationDialog();
    },
    hideConfirmationDialog() {
      this.$data.showConfirmationModal = false;
      this.currentConfirmationModalAffirmativeFunc = (): void => undefined;
      if (this.$data.confirmationModalQueue.length) {
        setTimeout(() => {
          const confirmationModalData = this.$data.confirmationModalQueue.pop();
          this.$data.confirmationModalTitle = confirmationModalData.confirmationModalTitle;
          this.$data.confirmationModalMsg = confirmationModalData.confirmationModalMsg;
          this.$data.currentConfirmationModalAffirmativeFunc = confirmationModalData.currentConfirmationModalAffirmativeFunc;
          this.$data.currentConfirmationModalNegativeFunc = confirmationModalData.currentConfirmationModalNegativeFunc;
        }, 500); // Open the next pop up in 500 milleseconds so that the user is alerted by the animation, rather than just injecting the already visible popup with new data.
      }
    },
    onCodeTextClick() {
      (this.$refs.codeText as HTMLElement).scrollIntoView({ block: 'start', behavior: 'smooth' });
      (this.$refs.virtualKeyboard as HTMLElement).classList.add('keyboard-wiggle');
      setTimeout(() => {
        (this.$refs.virtualKeyboard as HTMLElement).classList.remove('keyboard-wiggle');
      }, 200);
    },
    onSamePlaceSelection() {
      this.$data.showSameStationCodePrompt = false;
      this.showPromotionModalFunc(true);
    },
    showPromotionModalFunc(onInit = false) {
      const promo: Promotion = this.$store.state.currentLocation.promotion;
      if (this.$store.state.currentLocation && promo) {
        const lastViewedPromotion: string | null = Util.localStoreGet('lastViewedPromotion');
        const currPromotion: string = promo.docId;

        // Do not show if user already saw this promotion during this session or if the station code prompt is showing.
        if (!onInit || (lastViewedPromotion !== currPromotion && !this.showSameStationCodePrompt && promo.showOnSessionStart)) {
          this.$data.carouselKey++;
          this.$data.showPromotionModal = true;
          Util.localStoreSet('lastViewedPromotion', currPromotion);
        }
      }
    },
    setDefaultLanguage() {
      function getLang() {
        if (navigator.languages !== undefined) {
          return navigator.languages[0];
        }
        return navigator.language;
      }

      const language = getLang() || 'en';
      let localeCode = 'en';

      if (language.includes('fr')) {
        localeCode = 'fr';
      } else if (language.includes('es')) {
        localeCode = 'es';
      } else if (language.includes('zh')) {
        localeCode = 'zh';
      } else if (language.includes('de')) {
        localeCode = 'de';
      }

      if (this.$store.state.currentClientUser) {
        Util.updateCurrentClientUser({
          settings: {
            ...this.$store.state.currentClientUser.settings,
            locale: localeCode,
          },
        });
      } else {
        this.$store.commit('setLocale', localeCode);
      }
    },
    showSignInFunc(msg: string = '', allowClose: boolean = true) {
      const self = this;
      this.$data.showSignIn = true;
      this.$data.signInMessage = msg;
      this.$data.signInAllowClose = allowClose;

      if (this.$data.signInFormInitialized) {
        return;
      }

      function onSignInWithCredential(userCredential: firebase.auth.UserCredential, clientUserData: ClientUser | null = null) {
        const user = userCredential.user;
        if (user) {
          Util.nonDebugLog('Signed up new user: ', user);
          Util.setUpForSignedInAuthUser(user, clientUserData);
          Util.showSuccess(Util.t?.signInSuccessful);
        } else {
          Util.showError('No user provided by the signInWithCredential call.');
          self.$store.commit('setInitializationComplete', true);
        }
      }
      Vue.nextTick(() => {
        this.$data.uiConfig = {
          autoUpgradeAnonymousUsers: true,
          signInFlow: 'popup',
          credentialHelper: firebaseui.auth.CredentialHelper.NONE,
          signInOptions: [
            // Leave the lines as is for the providers you want to offer your users.
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            {
              provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
              requireDisplayName: true,
            },
          ],
          callbacks: {
            uiShown() {
              self.$data.signInFormInitialized = true;
            },
            signInSuccessWithAuthResult(authResult: any) {
              Util.eventBus.$emit('closeModals');
              firebase
                .auth()
                .signInWithCredential(authResult.credential)
                .then((userCredential) => {
                  onSignInWithCredential(userCredential);
                });
            },
            // signInFailure callback must be provided to handle merge conflicts which
            // occur when an existing credential is linked to an anonymous user.
            signInFailure(error: any) {
              // For merge conflicts, the error.code will be
              // 'firebaseui/anonymous-upgrade-merge-conflict'.
              if (error.code === 'firebaseui/anonymous-upgrade-merge-conflict') {
                // The credential the user tried to sign in with.
                const cred: firebase.auth.AuthCredential = error.credential;
                return ExchangeFuncs.deleteUserAndExchangeDoc()
                  .then((value: boolean) => {
                    return firebase
                      .auth()
                      .signInWithCredential(cred)
                      .then((userCredential) => {
                        onSignInWithCredential(userCredential);
                        Promise.resolve();
                      })
                      .catch((signInError) => {
                        Util.showError(`Could not sign in with credential: ${error?.message}`);
                        Promise.reject(signInError);
                      });
                  })
                  .catch((deleteError) => {
                    Util.showError(`Could not delete the old exchange doc: ${error?.message}`);
                    Promise.reject(deleteError);
                  });
              } else {
                Util.showError(`Sign in failure: ${error?.message}`);
                return Promise.resolve();
              }
            },
          },
        };
        // Initialize the FirebaseUI Widget using Firebase.
        this.$data.authUi = new firebaseui.auth.AuthUI(firebase.auth());
        // The start method will wait until the DOM is loaded.
        this.$data.authUi.start('#firebaseui-auth-container', this.$data.uiConfig);
      });
    },
    resetSignIn() {
      this.$data.authUi.reset();
      this.$data.authUi.start('#firebaseui-auth-container', this.$data.uiConfig);
    },
    setTheme(theme: any) {
      this.$data.currTheme = theme.themeName;
      Util.initTheme(theme);
    },
    setMode(mode: Enums.eAppModes) {
      this.$store.commit('setAppMode', mode);
    },
    onDemoMenuClose() {
      this.$router.go(-1);
      setTimeout(() => {
        this.beginTutorial();
      }, 1000);
    },
  },
  watch: {
    $route(to, from) {
      this.$data.isFullNav = false;
    },
  },
});
